
import React from 'react';
import { Container } from 'react-bootstrap';
import { motion } from 'framer-motion';

const Home = () => {
  return (
    <section id="home" className="home-section">
      <div className="jumbotron fluid text-center bg-primary text-white">
        <Container>
          <motion.h1
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
          >
            Welcome to SigisBell
          </motion.h1>
          <motion.p
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1, delay: 0.5 }}
          >
            Your trusted partner for Home Inspection Services, Tax Services, Concierge Services, and Cleaning Services are here for you.
            We deliver exceptional services to our customers. Give us a call for a nice rate, and we are looking forward to working with you!
            Once you become our clients,you are a member of the SigisBell family. Call us today: 943-223-0218
            
          </motion.p>
        </Container>
      </div>
    </section>
  );
}

export default Home;
